import { MouseEvent as ReactMouseEvent, useEffect, useRef, useState } from 'react'
import { withStyles, Theme } from '@material-ui/core/styles'
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip'

/** change tooltip text size here */
const ThemedTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    fontSize: theme.typography.pxToRem(15)
  }
}))(Tooltip)

export interface CustomTooltipProps extends TooltipProps {
  disableTooltip?: boolean
  divAttributes?: { [key: string]: any }
  clickToToggle?: boolean
}

const CustomTooltip = ({
  title,
  children,
  divAttributes,
  disableTooltip,
  placement,
  clickToToggle = false,
  ...tooltipProps
}: CustomTooltipProps) => {
  const [open, setOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement | null>(null)
  const { onClick: divOnClick, ...restDivAttributes } = divAttributes || {}

  useEffect(() => {
    if (!clickToToggle) return

    const handleDocumentClick = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false)
      }
    }

    document.addEventListener('click', handleDocumentClick)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [clickToToggle])

  const handleWrapperClick = (event: ReactMouseEvent<HTMLDivElement>) => {
    divOnClick?.(event)
    setOpen((prev) => !prev)
  }

  return (
    <div
      {...restDivAttributes}
      ref={containerRef}
      onClick={clickToToggle ? handleWrapperClick : divOnClick}
    >
      {disableTooltip ? (
        children
      ) : (
        <ThemedTooltip
          enterTouchDelay={5}
          leaveTouchDelay={10000}
          title={title}
          placement={placement || 'bottom'}
          {...tooltipProps}
          {...(clickToToggle
            ? {
                open,
                onClose: () => setOpen(false),
                disableFocusListener: true,
                disableHoverListener: true,
                disableTouchListener: true
              }
            : {})}
        >
          {children}
        </ThemedTooltip>
      )}
    </div>
  )
}

export default CustomTooltip
